var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdbPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM2.00293 7.70215V8.24219L12.0029 12.9053L20.9795 8.74316V10.4375L12.0029 14.6396L2.51465 10.1699L2.00391 10.4014L2.00293 13.6377L12.0029 18.3027L20.9795 14.1396V15.7969L12.0029 19.9961L2.51465 15.5264L2.00391 15.7578V16.335L12.0029 21L22.0029 16.3369V13.0986L21.5371 12.8672L12.0029 17.3389L3.07324 13.0986V11.4414L12.0029 15.6035L22.0029 10.9404V7.74023L21.5371 7.50879L12.0029 11.9805L3.53906 8.01074L12.0029 4.04102L19.0254 7.31738L19.6299 7.00879V6.58398L12.0029 3L2.00293 7.70215Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdbPlatform);
export default __webpack_public_path__ + "static/media/ADB_Platform.59761e8cebe26b8c4e719a7b937ebaef.svg";
export { ForwardRef as ReactComponent };